/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPlanningResponse } from '../../models/get-planning-response';

export interface PlanningsControllerGetPlanning$Params {
  id: string;

/**
 * Language code of the application performing API request.
 */
  'x-ca-application-lang-code'?: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * A header used for security reasons. Header is automatically sent by browsers. When using the code-to-API solution (calling this API directly by script code or other API) please contact <strong>Customer Apps</strong> team for more details.
 */
  referer?: string;

/**
 * Authentication token from Viessmann IAM OAuth2. Required for VIESSMANN_IAM authentication.
 */
  authorization?: string;

/**
 * Application ID identifying the client application. Required for VIESSMANN_IAM authentication.
 */
  'x-application-id'?: 'HEAT_PUMP_PLANNER' | 'PHOTOVOLTAIC_PLANNER' | 'VENTILATION_PLANNER' | 'VIGUIDE_PLANNING' | 'HOME_PLANNER' | 'BOILER_PLANNER' | 'SALESFORCE' | 'CONFIGURATION_PORTAL';

/**
 * Country code of the client application instance. Required for VIESSMANN_IAM authentication.
 */
  'x-application-country-code'?: 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK' | 'LU';
}

export function planningsControllerGetPlanning(http: HttpClient, rootUrl: string, params: PlanningsControllerGetPlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPlanningResponse>> {
  const rb = new RequestBuilder(rootUrl, planningsControllerGetPlanning.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-ca-application-lang-code', params['x-ca-application-lang-code'], {});
    rb.header('referer', params.referer, {});
    rb.header('authorization', params.authorization, {});
    rb.header('x-application-id', params['x-application-id'], {});
    rb.header('x-application-country-code', params['x-application-country-code'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPlanningResponse>;
    })
  );
}

planningsControllerGetPlanning.PATH = '/planning-projects/v1/projects/variants/plannings/{id}';
